export default [
  ["fas", "paw"],
  ["fas", "carrot"],
  ["fas", "leaf"],
  ["fas", "utensils"],
  ["fas", "burn"],
  ["fas", "atom-alt"],
  ["fas", "ball-pile"],
  ["fas", "skull-cow"],
  ["fas", "trees"],
  ["fas", "scroll"],
  ["fas", "tshirt"],
  ["fas", "shoe-prints"],
  ["fas", "glass"],
  ["fas", "gem"],
  ["fas", "hammer-war"],
  ["fas", "plug"],
  ["fas", "car"],
  ["fas", "watch"],
  ["fas", "swords"],
  ["fas", "couch"],
  ["fas", "landmark"],
];
